import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { pick } from 'lodash';

import withPermissions from '../utils/with-affiliate-config';

const AuthorizedRoute = (props) => {
  const {
    hasPermissions,
    or = false,
    required,
    component: Component,
  } = props;

  const restProps = pick(props, ['exact', 'path', 'strict', 'sensitive']);

  return (
    <Route
      {...restProps}
      render={({ ...componentProps }) => (hasPermissions(required) ? <Component {...componentProps} /> : (or && or(componentProps)))}
    />
  );
};

AuthorizedRoute.propTypes = {
  required: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  hasPermissions: PropTypes.func,
  component: PropTypes.func,
  or: PropTypes.func,
};

const AuthorizedRouteExport = withPermissions(AuthorizedRoute);
export default AuthorizedRouteExport;



// WEBPACK FOOTER //
// ./src/components/AuthorizedRoute.js